export default "__VITE_PUBLIC_ASSET__1fa5c6af__"